import React from 'react';

import { PrimaryFilters as PrimaryFiltersProvider } from 'components/Filters';

import { useIsAllowed } from '@gogame/permissions';

import {
  FILTER_PERIOD,
  FILTER_PAY_TO,
  FILTER_TRAFFIC_TYPE,
  FILTER_APPLICATIONS,
  PERMISSION_ID,
} from 'scenes/Trackers/Tracker/constants';

import { CreativeFilters } from 'scenes/Trackers/CreativeFilters';
import TrackerFilters, { InfluencerChannelFilters } from './filters';

export const PRIMARY_FILTERS = [
  FILTER_PERIOD,
  FILTER_PAY_TO,
  FILTER_TRAFFIC_TYPE,
  FILTER_APPLICATIONS,
];

const PrimaryFilters = ({ onLockPayTo, payToLocked }) => {
  const isAllowed = useIsAllowed();

  return (
    <PrimaryFiltersProvider primary={PRIMARY_FILTERS}>
      <TrackerFilters.RegistrationPeriod payToLocked={payToLocked} />
      <TrackerFilters.PayTo locked={payToLocked} onLock={onLockPayTo} />
      {TrackerFilters.TrafficType ? <TrackerFilters.TrafficType /> : null}
      <TrackerFilters.Applications withClear={true} />
      <TrackerFilters.Networks withClear={true} />
      <TrackerFilters.Clusters withClear={true} />
      {TrackerFilters.BusinessPartners ? (
        <TrackerFilters.BusinessPartners
          dropdownWidth={'440px'}
          withClear={true}
        />
      ) : null}
      {TrackerFilters.Affiliates && (
        <TrackerFilters.Affiliates dropdownWidth={'440px'} withClear={true} />
      )}
      <TrackerFilters.Campaigns dropdownWidth={'440px'} withClear={true} />
      {TrackerFilters.Managers ? (
        <TrackerFilters.Managers withClear={true} />
      ) : null}
      {TrackerFilters.Owners ? (
        <TrackerFilters.Owners withClear={true} />
      ) : null}
      <TrackerFilters.Platforms withClear={true} />
      {TrackerFilters.Genres ? (
        <TrackerFilters.Genres withClear={true} />
      ) : null}

      <TrackerFilters.Countries withClear={true} />
      <TrackerFilters.RealCountries withClear={true} />
      {TrackerFilters.ChannelTypes ? (
        <TrackerFilters.ChannelTypes withClear={true} />
      ) : null}
      {TrackerFilters.Channels ? (
        <TrackerFilters.Channels withClear={true} />
      ) : null}
      {TrackerFilters.Labels ? (
        <TrackerFilters.Labels withClear={true} />
      ) : null}
      {TrackerFilters.Clients ? (
        <TrackerFilters.Clients withClear={true} />
      ) : null}
      {TrackerFilters.DeviceType ? (
        <TrackerFilters.DeviceType withClear={true} />
      ) : null}
      <TrackerFilters.CPFlow withClear={true} />
      <TrackerFilters.Registrations withClear={true} />
      <TrackerFilters.CampaignType withClear={true} />
      {TrackerFilters.Statuses && <TrackerFilters.Statuses withClear={true} />}
      <TrackerFilters.FraudType withClear={true} />
      {TrackerFilters.RECounter ? (
        <TrackerFilters.RECounter withClear={true} />
      ) : null}
      {TrackerFilters.CPELiveEvents ? (
        <TrackerFilters.CPELiveEvents withClear={true} />
      ) : null}
      {TrackerFilters.CPELiveEventType ? (
        <TrackerFilters.CPELiveEventType withClear={true} />
      ) : null}
      {InfluencerChannelFilters.Subscribers && (
        <InfluencerChannelFilters.Subscribers withClear={true} />
      )}
      {InfluencerChannelFilters.TotalViews && (
        <InfluencerChannelFilters.TotalViews withClear={true} />
      )}
      {InfluencerChannelFilters.Prices ? (
        <InfluencerChannelFilters.Prices withClear={true} />
      ) : null}
      {InfluencerChannelFilters.SocialMediaPlatforms ? (
        <InfluencerChannelFilters.SocialMediaPlatforms withClear={true} />
      ) : null}
      {InfluencerChannelFilters.Genders ? (
        <InfluencerChannelFilters.Genders withClear={true} />
      ) : null}
      {InfluencerChannelFilters.Briefs ? (
        <InfluencerChannelFilters.Briefs withClear={true} />
      ) : null}

      {isAllowed(PERMISSION_ID) ? (
        <React.Fragment>
          <CreativeFilters.CreationPeriod withClear={true} />
          <CreativeFilters.ConceptCreationPeriod withClear={true} />
          {CreativeFilters.Statuses && (
            <CreativeFilters.Statuses withClear={true} />
          )}
          {CreativeFilters.CreatedBy && (
            <CreativeFilters.CreatedBy withClear={true} />
          )}
          <CreativeFilters.CreativeTypes withClear={true} />
          <CreativeFilters.Languages withClear={true} />
          <CreativeFilters.MediaTypes withClear={true} />
          <CreativeFilters.Lengths withClear={true} />
          <CreativeFilters.Orientations withClear={true} />
          {CreativeFilters.RequestedBy && (
            <CreativeFilters.RequestedBy withClear={true} />
          )}
          <CreativeFilters.Resolutions withClear={true} />
          <CreativeFilters.Sizes withClear={true} />
          {CreativeFilters.Authors && (
            <CreativeFilters.Authors withClear={true} />
          )}
          {CreativeFilters.ProductionTypes && (
            <CreativeFilters.ProductionTypes withClear={true} />
          )}
          <CreativeFilters.Enhancers withClear={true} />
          <CreativeFilters.OS withClear={true} />
          <CreativeFilters.Colors withClear={true} />
          <CreativeFilters.IncludedTags withClear={true} />
          <CreativeFilters.ExcludedTags withClear={true} />
          <CreativeFilters.EndCard withClear={true} />
          {CreativeFilters.Tested && (
            <CreativeFilters.Tested withClear={true} />
          )}
          {CreativeFilters.AICreated && (
            <CreativeFilters.AICreated withClear={true} />
          )}
        </React.Fragment>
      ) : null}
    </PrimaryFiltersProvider>
  );
};

export default PrimaryFilters;
